import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import logo from '../styles/2lineaaplogopositive_lowres.png';
import { Link } from '@mui/material';

//This component implements a common header for use by
// all Features apps. It mimics the header shown on pages for 
// aap.org. However, Features doesn't have navigation so that
// component is not implemented here.
// Props: The header contains a block with the name of the app
// or a message. This is passed in from the caller in Props
// 
interface IHeaderProps {
  message: string,
  cobrandedLogProps?: ICobrandedLogProps
}

export interface ICobrandedLogProps {
    source: string,
    url: string,
    text: string   
}

export default function Header( headerInfo: IHeaderProps){
    return (
        <Box >
            <Box sx={{p:2, display: 'flex'}}>
                <Link sx={{m:0}} href={process.env.REACT_APP_AAP_URL}>
                <img src={logo} alt="AAP Logo" style={{ maxWidth: 300, maxHeight: 91 }} />
                </Link>
            </Box>
            {headerInfo.cobrandedLogProps != null && 
            <Box sx={{paddingLeft: 5, paddingBottom: 3, display: 'flex'}}>
                <Link href={headerInfo.cobrandedLogProps.url}>
                <img src={headerInfo.cobrandedLogProps.source} alt={headerInfo.cobrandedLogProps.text} />
                </Link>
            </Box>}
            <Box sx={{p:7, bgcolor: 'primary.dark', fontWeight:700 }} >
                 <Typography variant="h2"color="common.white">
                 {headerInfo.message}
                 </Typography>
            </Box>
        </Box>
    );
}